import { render, staticRenderFns } from "./third-party.vue?vue&type=template&id=660c3bc1"
import script from "./third-party.vue?vue&type=script&lang=js"
export * from "./third-party.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports